import {ClickAwayListener, IconButton, Popover, Stack} from "@mui/material";
import React, {useRef, useState} from "react";
import DeleteForeverOutlinedIcon from '@mui/icons-material/DeleteForeverOutlined';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';

export function Delete({onConfirm}:{onConfirm:() => void}) {
    const [showPopover, setShowPopover] = useState(false);
    const ref = useRef(null);
    return <ClickAwayListener onClickAway={() => setShowPopover(false)}>
        <div>
        <IconButton onClick={() => setShowPopover(true)} ref={ref}>
            {showPopover
                ? <DeleteForeverOutlinedIcon color={"error"}/>
                : <DeleteOutlineIcon color={"error"}/>}
        </IconButton>

            <Popover
                open={showPopover}
                anchorEl={ref.current}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'center',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'center',
                }}
            >
                <Stack flexDirection={"column"} alignItems={"stretch"}>
                    <div style={{margin: "5px 10px"}}>Really Delete?</div>
                    <Stack flexDirection={"row"} justifyContent={"space-around"}>
                        <IconButton onClick={() => setShowPopover(false)}>
                            <HighlightOffIcon color={"success"}/>
                        </IconButton>
                        <IconButton onClick={() => {
                            setShowPopover(false);
                            onConfirm();
                        }}>
                            <CheckCircleOutlineIcon color={"error"} />
                        </IconButton>
                    </Stack>
                </Stack>
            </Popover>
        </div>
    </ClickAwayListener>
}